import React from 'react'
import styled from 'styled-components'
import StoryPreview from './StoryPreview'
import { graphql, StaticQuery } from 'gatsby'
import { useMediaQuery } from 'react-responsive'

const StoriesList = styled.div`
width: 100%;
padding-left: 20px;
height: 100%;

overflow-y: auto;
  ::-webkit-scrollbar {
    display: none;
  };
}
`

const StoriesListElement = (props) => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1025px)' });
  const { edges: stories } = props.data.allMarkdownRemark;
  const currentStory = isTabletOrMobile ? null : stories.find(story => story.node.fields.slug === props.currentStory);

  return (
    <StoriesList>
      <h1 className='white' style={{marginLeft: '15px'}}>Stories</h1>
      { isTabletOrMobile ? null :
      <StoryPreview currentStory key={currentStory.node.fields.slug} image={currentStory.node.frontmatter.image.childImageSharp.fixed} 
                        title={currentStory.node.frontmatter.title} excerpt={currentStory.node.excerpt} url={currentStory.node.fields.slug} />
      }
      {stories.map(story => {
        if (story.node.fields.slug === props.currentStory) { return null } else {
          return (
            <StoryPreview key={story.node.fields.slug} image={story.node.frontmatter.image.childImageSharp.fixed} 
                          title={story.node.frontmatter.title} excerpt={story.node.excerpt} url={story.node.fields.slug} />
          )
        }
      })}
    </StoriesList>
  )
}

export default (props) => (
  <StaticQuery
    query={graphql`
      query StoriesListQuery {
        allMarkdownRemark(
          sort: { order: DESC, fields: [frontmatter___date] }
          filter: { frontmatter: { templateKey: { eq: "storiesTemplate" } } }
        ) {
          edges {
            node {
              excerpt(pruneLength: 185)
              fields {
                slug
              }
              frontmatter {
                title
                templateKey
                date(formatString: "MMMM DD, YYYY")
                image {
                  childImageSharp {
                    fixed(width: 310, height: 160, quality: 30, cropFocus: CENTER) {
                      ...GatsbyImageSharpFixed
                    }
                  }
                } 
              }
            }
          }
        }
      }
    `}
    render={(data) => <StoriesListElement data={data} {...props} />}
  />
)